import {Component} from "@theme/component";
import {debounce, onDocumentLoaded, setHeaderMenuStyle} from "@theme/utilities";
import {MegaMenuHoverEvent} from "@theme/events";
class HeaderMenu extends Component {
    requiredRefs = [];
    #submenuMutationObserver = null;
    connectedCallback() {
        super.connectedCallback(),
        this.#cacheMaxOverflowMenuHeight(),
        onDocumentLoaded(this.#preloadImages),
        window.addEventListener("resize", this.#resizeListener),
        document.addEventListener("click", this.#handleDocumentClick)
    }
    disconnectedCallback() {
        super.disconnectedCallback(),
        window.removeEventListener("resize", this.#resizeListener),
        document.removeEventListener("click", this.#handleDocumentClick),
        this.#cleanupMutationObserver()
    }
    #resizeListener = debounce( () => {
        this.#cacheMaxOverflowMenuHeight(),
        setHeaderMenuStyle()
    }
    , 100);
    #state = {
        activeItem: null
    };
    get overflowMenu() {
        return this.refs.overflowMenu?.shadowRoot?.querySelector('[part="overflow"]')
    }
    get headerComponent() {
        return this.closest("header-component")
    }
    toggle = event => {
        this.dispatchEvent(new MegaMenuHoverEvent);
        const target = event.composedPath?.()[0] ?? event.target;
        if (!(target instanceof Element))
            return;
        if (target.closest(".menu-list__submenu a[href], .mega-menu-nested a[href]")) {
            this.#deactivate();
            return
        }
        let item = findMenuItem(target);
        if (!item)
            return;
        if (findSubmenu(item)) {
            if (event.preventDefault(),
            item === this.#state.activeItem) {
                this.#deactivate();
                return
            }
            this.#activate(item)
        }
    }
    ;
    #activate = item => {
        const previouslyActiveItem = this.#state.activeItem;
        previouslyActiveItem && (previouslyActiveItem.ariaExpanded = "false"),
        this.#state.activeItem = item,
        this.ariaExpanded = "true",
        item.ariaExpanded = "true";
        let submenu = findSubmenu(item);
        const isDefaultSlot = item.closest("[slot]")?.slot !== "overflow";
        !submenu && !isDefaultSlot && (submenu = this.overflowMenu),
        submenu && (submenu.dataset.active = "",
        this.#cleanupMutationObserver(),
        this.#submenuMutationObserver = new MutationObserver( () => {
            requestAnimationFrame( () => {
                requestAnimationFrame( () => {
                    submenu.offsetHeight > 0 && (this.headerComponent?.style.setProperty("--submenu-height", `${submenu.offsetHeight}px`),
                    this.#cleanupMutationObserver())
                }
                )
            }
            )
        }
        ),
        this.#submenuMutationObserver.observe(submenu, {
            childList: !0,
            subtree: !0
        }),
        setTimeout( () => {
            this.#cleanupMutationObserver()
        }
        , 500));
        const submenuHeight = submenu ? submenu.offsetHeight : 0;
        this.headerComponent?.style.setProperty("--submenu-height", `${submenuHeight}px`),
        this.style.setProperty("--submenu-opacity", "1"),
        this.dataset.overflowExpanded = "false"
    }
    ;
    #handleDocumentClick = event => {
        if (!this.#state.activeItem)
            return;
        const submenu = findSubmenu(this.#state.activeItem);
        this.contains(event.target) || submenu?.contains(event.target) || this.#deactivate()
    }
    ;
    #deactivate = (item=this.#state.activeItem) => {
        if (!item || item != this.#state.activeItem)
            return;
        this.headerComponent?.style.setProperty("--submenu-height", "0px"),
        this.style.setProperty("--submenu-opacity", "0"),
        this.dataset.overflowExpanded = "false";
        const submenu = findSubmenu(item);
        this.#state.activeItem = null,
        this.ariaExpanded = "false",
        item.ariaExpanded = "false",
        submenu && delete submenu.dataset.active
    }
    ;
    #preloadImages = () => {
        this.querySelectorAll('img[loading="lazy"]')?.forEach(image => image.removeAttribute("loading"))
    }
    ;
    #cacheMaxOverflowMenuHeight() {
        const submenus = this.querySelectorAll('[ref="submenu[]"]')
          , maxHeight = Math.max(...Array.from(submenus).filter(submenu => submenu instanceof HTMLElement).map(submenu => submenu.offsetHeight));
        this.headerComponent?.style.setProperty("--submenu-max-height", `${maxHeight}px`)
    }
    #cleanupMutationObserver() {
        this.#submenuMutationObserver?.disconnect(),
        this.#submenuMutationObserver = null
    }
}
customElements.get("header-menu") || customElements.define("header-menu", HeaderMenu);
function findMenuItem(element) {
    if (!(element instanceof Element)) return null;
    return element?.querySelector('[ref="menuitem"]') ?? element?.closest('[ref="menuitem"]');
}
function findSubmenu(element) {
    const submenu = element?.parentElement?.querySelector('[ref="submenu[]"]');
    return submenu instanceof HTMLElement ? submenu : null
}